import { createBrowserRouter, Navigate } from "react-router-dom"
import Layout from "./Layout"
import Login from "./pages/Login"
import Dashboard from "./pages/Dashboard"
import Statistic from "./pages/Statistic"
import Bot from "./pages/Bot"
import Clients from "./pages/Clients"
import Accounts from "./pages/Accounts"
import Matching from "./pages/Matching"
import Mails from "./pages/Mails"
import Users from "./pages/Users"
import Archive from "./pages/Archive"
import Logs from "./pages/Logs"
import Dumps from "./pages/Dumps"
import SiteVisitors from "./pages/SiteVisitors"
import WorkerActivity from "./pages/WorkerActivity"
// import Gmail from "./pages/Gmail"
// import Documentation from "./pages/Documentation"

import RequireAuth from "./components/RequireAuth"

export const router = createBrowserRouter([
  { path: "login", element: <Login /> },
  {
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "statistic", element: <Statistic /> },
      {
        path: "bot",
        element: (
          <RequireAuth requiredRole="ADMIN">
            <Bot />
          </RequireAuth>
        ),
      },
      { path: "clients", element: <Clients /> },
      { path: "accounts", element: <Accounts /> },
      { path: "matching", element: <Matching /> },
      { path: "profiles", element: <Navigate to="/matching" replace /> },
      { path: "listings", element: <Navigate to="/matching" replace /> },
      { path: "jobs", element: <Navigate to="/matching" replace /> },
      { path: "mails", element: <Mails /> },
      {
        path: "users",
        element: (
          <RequireAuth requiredRole="ADMIN">
            <Users />
          </RequireAuth>
        ),
      },
      {
        path: "dumps",
        element: (
          <RequireAuth requiredRole="ADMIN">
            <Dumps />
          </RequireAuth>
        ),
      },
      {
        path: "site-visitors",
        element: (
          <RequireAuth requiredRole="ADMIN">
            <SiteVisitors />
          </RequireAuth>
        ),
      },
      {
        path: "activity",
        element: (
          <RequireAuth requiredRole="ADMIN">
            <WorkerActivity />
          </RequireAuth>
        ),
      },
      // { path: "gmail", element: <Gmail /> },
      { path: "archive", element: <Archive /> },
      { path: "logs", element: <Logs /> },
      // { path: "documentation", element: <Documentation /> },
      { path: "*", element: <Navigate to="/dashboard" replace /> },
    ],
  },
])
